import type { Prototype } from "../prototype-types";

export const kanikaAroraPrototypes: Prototype[] = [
  {
    id: "kar-magic-signup-edge-cases",
    name: "Magic Retailer Signup - Edge Cases",
    path: "/kar/magic-signup-edge-cases",
    description:
      "Magic retailer signup thin card edge cases. Fields follow the business type (brick and mortar / pop up: name, website, postal code; online / somewhere else: name, website). Variants: all found editable (control), all found read-only, and for partial fields the plain control journey (no card), Variant 4 (website asked later) and Variant 5 (zip or business name asked later). Business types are merged into brick and mortar / pop up and online only / other. Mock-only.",
    owner: "Kanika Arora",
    createdAt: "2026-10-25",
    lastUpdated: "2026-10-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0d4715452d8613597dfb050917271f78d2f54176f54ca964318a843ccb0c881d.png",
  },
];
